import { User } from 'lucide-react'
import { memo } from 'react'
import { Link } from 'react-router-dom'

import { Link as LinkComp } from '@/components/Link'
import { useView } from '@/hooks'
import { Beneficiary } from '@/store/beneficiary'
import { useStoreState } from '@/store/hooks'

export const BeneficiaryLink = memo(function ({
  className,
  fullName,
  id,
  onClick,
  withIcon = true,
}: {
  className?: string
  fullName: Beneficiary['fullName']
  id: Beneficiary['id']
  onClick?: () => void
  withIcon?: boolean
}) {
  const organizationId = useStoreState((state) => state.user.currentOrganizationId)
  const beneficiaryId = useStoreState((state) => state.beneficiary.currentBeneficiaryId)
  const view = useView()
  if (!organizationId) return null
  return (
    <LinkComp className={className} disabled={beneficiaryId === id} tabIndex={-1} asChild>
      <Link to={view.beneficiary(id).profile.route} onClick={() => onClick?.()}>
        {withIcon && <User className="size-4" />}
        {fullName}
      </Link>
    </LinkComp>
  )
})
